import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["childNodeIds"];
import { immerable } from 'immer';
import GridNode from './GridNode';
import { GRID_NODE_TYPES, STACK_DIRECTIONS } from './constants';
import { mergeIntoPath } from './utils';
import { isGridContainerLayout, isStackContainerLayout } from './typenameUtils';
export default class ContainerNode extends GridNode {
  constructor(_ref) {
    let {
        childNodeIds = []
      } = _ref,
      containerNodeParams = _objectWithoutPropertiesLoose(_ref, _excluded);
    super(containerNodeParams);
    this[immerable] = true;
    this._childNodeIds = childNodeIds;
  }
  cloneAndChange(containerNodeParams) {
    const {
      id,
      childNodeIds,
      parentNodeId,
      value,
      treeRef
    } = containerNodeParams;
    const newNodeParams = {
      id: id !== null && id !== void 0 ? id : this._id,
      type: GRID_NODE_TYPES.CONTAINER,
      treeRef: treeRef !== null && treeRef !== void 0 ? treeRef : this._treeRef,
      childNodeIds: childNodeIds !== null && childNodeIds !== void 0 ? childNodeIds : this._childNodeIds,
      parentNodeId: parentNodeId !== null && parentNodeId !== void 0 ? parentNodeId : this._parentNodeId,
      value: value !== null && value !== void 0 ? value : this._value
    };
    return newNodeParams.treeRef.createNewContainer(newNodeParams);
  }
  exportNode() {
    return {
      id: this.getId(),
      value: this.getValue(),
      parentNodeId: this.getParentNodeId(),
      childNodeIds: [...this.getChildNodeIds()]
    };
  }
  getChildNodes() {
    return this.getChildNodeIds().map(childNodeId => this.getTree().findNode(childNodeId));
  }
  mergeIntoValue(partialValue, path) {
    return this.cloneAndChange({
      value: mergeIntoPath(this._value, partialValue, path)
    });
  }
  mergeIntoStyles(partialStyles, path) {
    return this.cloneAndChange({
      value: Object.assign({}, this._value, {
        styles: mergeIntoPath(this._value.styles, partialStyles, path)
      })
    });
  }
  isChildOfSection() {
    return this.getParentNode().isSection();
  }
  getContainerLayout(breakpoint = 'default') {
    return this._value.layout.layout[breakpoint] || this._value.layout.layout.default;
  }
  isGrid(breakpoint = 'default') {
    return isGridContainerLayout(this.getContainerLayout(breakpoint));
  }
  isStack(breakpoint = 'default') {
    return isStackContainerLayout(this.getContainerLayout(breakpoint));
  }
  isHorizontalStack(breakpoint = 'default') {
    const stackLayout = this.getContainerLayout(breakpoint);
    return isStackContainerLayout(stackLayout) && stackLayout.direction === STACK_DIRECTIONS.HORIZONTAL;
  }
  isVerticalStack(breakpoint = 'default') {
    const stackLayout = this.getContainerLayout(breakpoint);
    return isStackContainerLayout(stackLayout) && stackLayout.direction === STACK_DIRECTIONS.VERTICAL;
  }
  getBreakpointStyles(breakpoint = 'default') {
    const defaultStyles = Object.assign({}, this._value.styles.breakpointStyles.default);
    if (breakpoint !== 'default') {
      return Object.assign({}, defaultStyles, this._value.styles.breakpointStyles[breakpoint]);
    }
    return defaultStyles;
  }
}